exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-ai-annotation-edit-content{width:19rem;max-width:calc(100vw - 2rem);box-sizing:border-box;padding-left:.75rem;padding-right:.75rem}", ""]);

// exports
